/**
 * 最外层容器
 */
import { isInDocument } from './isInDocument';
import { getDefaultContainer } from '../../config';
var Container = null;

var getContainer = function getContainer() {
  if (Container && isInDocument(Container)) {
    return Container;
  }

  Container = document.createElement('div');
  Container.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; contain: size');
  var target = getDefaultContainer();
  target.appendChild(Container);
  return Container;
};

export default getContainer;